import React, { useContext, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { TimelineContext } from '../../../../../contexts/TimelineContext'
import TimelineSidebar from './TimelineSidebar'
import TimelineHeader from './TimelineHeader'
import TimelineCalander from './TimelineCalander'
import TimelinePageLayout from '../../../../Shared/TimelineParts/TimelinePageLayout'

export default observer(function TimelineContent() {
  const [activeSidebarTab, setActiveSidebarTab] = useState('timeline')
  const { layout } = useContext(TimelineContext)

  if (layout === 'embedded') {
    return (
      <div className="flex w-full min-h-[480px] max-h-[min(720px,75vh)] rounded-lg border border-rb-widget-border dark:border-rb-dark-mode-lighter bg-rb-grey dark:bg-rb-dark-mode overflow-hidden">
        <TimelineSidebar activeTab={activeSidebarTab} />
        <div className="flex min-h-0 min-w-0 flex-1 flex-col border-l border-rb-widget-border dark:border-rb-dark-mode-lighter">
          <TimelineHeader
            activeTab={activeSidebarTab}
            onTabChange={setActiveSidebarTab}
          />
          <TimelineCalander />
        </div>
      </div>
    )
  }

  return (
    <TimelinePageLayout
      header={
        <TimelineHeader
          activeTab={activeSidebarTab}
          onTabChange={setActiveSidebarTab}
        />
      }
      sidebar={<TimelineSidebar activeTab={activeSidebarTab} />}
      calendar={<TimelineCalander />}
    />
  )
})
